/* eslint-disable no-redeclare */
import { z } from 'zod';

export const JourneyAlias = z.enum([
  'HEALTH_DEFAULT',
  'MEDICARE_ADVANTAGE',
  'MEDICARE_GENERIC',
  'MEDICARE_SUPPLEMENT',
  'LIFE_INSURANCE',
  '112', // MP-2416 Health - remove tobacco plate
]);
export type JourneyAlias = z.infer<typeof JourneyAlias>;
